import angular from 'angular';
import formKeyContacts from './keycontactForm';
import './style.scss';

export default angular
  .module('components.addFormKeyContacts', [])
  .component('addFormKeyContacts', formKeyContacts).name;
